import { render, staticRenderFns } from "./File_record_list.vue?vue&type=template&id=58d3c6ba&scoped=true"
import script from "./File_record_list.vue?vue&type=script&lang=js"
export * from "./File_record_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d3c6ba",
  null
  
)

export default component.exports